import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "addressContainer", "addressInput", "paymentNotice" ]

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.element.querySelector('input[name="collection_type"]:checked')
    
    if (selected && selected.value === "home") {
      this.addressContainerTarget.classList.remove("hidden")
      this.addressInputTarget.required = true
      if (this.hasPaymentNoticeTarget) {
        this.paymentNoticeTarget.textContent = "Payment is collected directly by the phlebotomist at home."
      }
    } else {
      this.addressContainerTarget.classList.add("hidden")
      this.addressInputTarget.required = false
      if (this.hasPaymentNoticeTarget) {
        this.paymentNoticeTarget.textContent = "Payment is collected at the center during your visit."
      }
    }
  }
}
